
// auth
export const POST_LOGIN = "/auth/sign-in"
export const POST_FORGOT_PASSWORD = "/auth/forgot-password"
export const POST_RESET_PASSWORD = "/auth/reset-password"


export const POST_CHANGE_PASSWORD = "/dashboard/change-password"
export const GET_DASHBOARD_DATA = "/dashboard/dashboard"

//setting
export const GET_ALL_SETTING = "/setting/get-all-setting"
export const POST_UPDATE_SETTING = "/setting/update-setting"

//Users
export const POST_USERS_LIST = process.env.REACT_APP_API_URL+"user/all"
export const DELETE_USERS = "/user/delete"
export const POST_UPDATE_USERS_STATUS = "/user/update-status"


// Item
export const POST_ITEM_LIST = process.env.REACT_APP_API_URL+"item/all"
export const DELETE_ITEM = "/item/delete"
export const POST_UPDATE_ITEM_STATUS = "/item/update-status"
export const POST_ADD_EDIT_ITEM = "/item/add-edit"
export const POST_GET_ITEM_DETAIL = "/item/detail"

// karate
export const POST_KARATE_LIST = process.env.REACT_APP_API_URL+"karate/all"
export const DELETE_KARATE = "/karate/delete"
export const POST_UPDATE_KARATE_STATUS = "/karate/update-status"
export const POST_ADD_EDIT_KARATE = "/karate/add-edit"
export const POST_GET_KARATE_DETAIL = "/karate/detail"

// shades
export const POST_SHADE_LIST = process.env.REACT_APP_API_URL+"shade/all"
export const DELETE_SHADE = "/shade/delete"
export const POST_UPDATE_SHADE_STATUS = "/shade/update-status"
export const POST_ADD_EDIT_SHADE = "/shade/add-edit"
export const POST_GET_SHADE_DETAIL = "/shade/detail"

// stone
export const POST_STONE_LIST = process.env.REACT_APP_API_URL+"stone/all"
export const DELETE_STONE = "/stone/delete"
export const POST_UPDATE_STONE_STATUS = "/stone/update-status"
export const POST_ADD_EDIT_STONE = "/stone/add-edit"
export const POST_GET_STONE_DETAIL = "/stone/detail"

// category
export const POST_CATEGORY_LIST = process.env.REACT_APP_API_URL+"category/all"
export const DELETE_CATEGORY = "/category/delete"
export const POST_UPDATE_CATEGORY_STATUS = "/category/update-status"
export const POST_ADD_EDIT_CATEGORY = "/category/add-edit"
export const POST_GET_CATEGORY_DETAIL = "/category/detail"
export const POST_GET_CATEGORY_FORM_OPTION = "/category/get-form-option"

// product
export const POST_PRODUCT_LIST = process.env.REACT_APP_API_URL+"product/all"
export const DELETE_PRODUCT = "/product/delete"
export const POST_UPDATE_PRODUCT_STATUS = "/product/update-status"

//reviews
export const POST_REVIEWS_LIST = process.env.REACT_APP_API_URL+"reviews/all"
export const DELETE_REVIEWS = "/reviews/delete"

//web order
export const POST_ORDER_LIST = process.env.REACT_APP_API_URL+"order/all"
export const POST_GET_ORDER_DETAIL = "/order/order-detail"
export const POST_UPDATE_ORDER_STATUS = "/order/update-status"
export const PRINT_ADDRESS = process.env.REACT_APP_API_URL.replace('/api/v1/','')+"/pdf/shipping?id="
export const PRINT_INVOICE = process.env.REACT_APP_API_URL.replace('/api/v1/','')+"/pdf/invoice?id="

// size
export const POST_SIZE_LIST = process.env.REACT_APP_API_URL+"size/all"
export const DELETE_SIZE = "/size/delete"
export const POST_UPDATE_SIZE_STATUS = "/size/update-status"
export const POST_ADD_EDIT_SIZE = "/size/add-edit"
export const POST_GET_SIZE_DETAIL = "/size/detail"
export const POST_GET_SIZE_FORM_OPTION = "/size/get-form-option"
